export const delay = (retryCount) => new Promise(
  (resolve) => {
    setTimeout(resolve, Math.max(retryCount * 2, 1) * 1e3);
  }
);
